import { motion } from "framer-motion";

const CHAPTERS = [
  {
    num: "01", title: "Precision Craft",
    body: "Every job gets the same standard: measured twice, done once, cleaned up after. We treat your home like it's the only job on the board — because for that day, it is.",
    span: "md:col-span-2",
  },
  {
    num: "02", title: "Pay At Job Site",
    body: "No deposits. No card forms. No online payments, ever. You look at the finished work first — then you pay, on the spot, cash or transfer.",
    span: "md:col-span-1",
  },
  {
    num: "03", title: "Upfront Transparency",
    body: "You get the estimate before we lift a tool. If the job changes, you hear it from us first — never on the invoice.",
    span: "md:col-span-1",
  },
  {
    num: "04", title: "Local & Accountable",
    body: "One local operator, one name on the job. When you book, you know exactly who's turning up at your door.",
    span: "md:col-span-2",
  },
];

export const Manifesto = () => (
  <section id="manifesto" data-testid="manifesto-section" className="py-20 lg:py-32 px-4 sm:px-8 lg:px-12 max-w-7xl mx-auto">
    <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7 }} className="mb-14">
      <p className="text-xs font-mono-brand uppercase tracking-[0.25em] text-amber-400 mb-4">03 — The Manifesto</p>
      <h2 className="text-4xl sm:text-5xl lg:text-6xl font-condensed font-extrabold uppercase tracking-tight leading-none">
        How We <span className="text-outline">Work</span>
      </h2>
    </motion.div>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
      {CHAPTERS.map((c, i) => (
        <motion.div key={c.num} data-testid={`manifesto-chapter-${c.num}`}
                    initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.6, delay: i * 0.12 }}
                    className={`${c.span} bg-[#0F172A] border border-amber-500/15 p-8 sm:p-10 relative overflow-hidden group hover:border-amber-500/50 transition-colors duration-300`}>
          <span className="absolute -top-4 -right-2 font-condensed font-black text-[7rem] leading-none text-amber-500/10 group-hover:text-amber-500/20 transition-colors duration-300 select-none">
            {c.num}
          </span>
          <p className="text-xs font-mono-brand uppercase tracking-[0.25em] text-amber-400 mb-4">Chapter {c.num}</p>
          <h3 className="text-xl sm:text-2xl font-condensed font-bold uppercase tracking-wide mb-4">{c.title}</h3>
          <p className="text-base leading-relaxed text-slate-300 max-w-md">{c.body}</p>
        </motion.div>
      ))}
    </div>
  </section>
);
